// extracted by mini-css-extract-plugin
export default {"uiInput":"input_form_uiInput__yN3Tp","container":"input_form_container__csC2q","inputIcon":"input_form_inputIcon__b4ApB"};